import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getDetailsURL, SET_NOTIFICATION_UPDATE_STATUS, SET_REVOKE_ACCESS_UPDATE_STATUS } from '../../Utility/DataguardConstant';
import { getAxiosHeaders, getService } from "../../../../library/RestAPI";

function* fetchDetailPageDataSaga(action) {
  const notificationStatus = yield select((state) => state.DataguardReducer.notificationUpdateStatus);
  const revokeAccessUpdateStatus = yield select((state) => state.DataguardReducer.revokeAccessUpdateStatus);
  try {
    const { pageType, apiEndpoint, fromTimeStamp, toTimeStamp, page, rowsPerPage, } = action.payload;
    yield put({ type: 'FETCH_DETAIL_PAGE_DATA_START' });
    let options = {
      method: "GET",
      url: `${getDetailsURL(apiEndpoint)}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&size=${rowsPerPage}&page=${page}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({
        type: 'FETCH_DETAIL_PAGE_DATA_SUCCESS',
        payload: { pageType, data: response.data || []}
      });
       if (notificationStatus) {
          yield put({ type: SET_NOTIFICATION_UPDATE_STATUS, payload: false });
        }
        if (revokeAccessUpdateStatus) {
          yield put({ type: SET_REVOKE_ACCESS_UPDATE_STATUS, payload: false });
        }
    } else {
      yield put({
        type: 'FETCH_DETAIL_PAGE_DATA_FAILURE',
        payload: 'API call failed'
      });
    }
  } catch (error) {
    yield put({
      type: 'FETCH_DETAIL_PAGE_DATA_FAILURE',
      payload: error.message
    });
  }
}

export default function* DetailPageSaga() {
  yield takeEvery('FETCH_DETAIL_PAGE_DATA_REQUEST', fetchDetailPageDataSaga);
}